// CfdImageSection.jsx
import React from "react";
import PropTypes from "prop-types";
import "./CfdImageSection.css";
import CfdImageCarousel from "../cfdComponents/CfdImageCarousel";
import CfdPropertyTag from "../cfdComponents/CfdPropertyTag";
import CfdFavoriteButton from "../cfdComponents/CfdFavoriteButton";

const CfdImageSection = ({
  item,
  isGridOrList,
  onNavigatePDP,
  activeTab,
  isModalOpen,
  showTags,
}) => {
  return (
    <div
      className={`cfd-image-section ${
        isModalOpen ? "cfd-img-modal-open" : "cfd-image-section-no-modal"
      }`}
      onClick={onNavigatePDP}
    >
      <CfdImageCarousel
        item={item}
        isGridOrList={isGridOrList}
        isMapCard={false}
        activeTab={activeTab}
        isModalOpen={isModalOpen}
      />

      {/* Property Tag - Top Left */}
      {!isModalOpen && (
        <div className="property-tag">
          <CfdPropertyTag item={item} activeTab={activeTab} />
        </div>
      )}

      {showTags && (
        <div className="property-tag">
          <CfdPropertyTag item={item} activeTab={activeTab} />
        </div>
      )}
    </div>
  );
};

CfdImageSection.propTypes = {
  item: PropTypes.object.isRequired,
  isGridOrList: PropTypes.bool,
  onNavigatePDP: PropTypes.func.isRequired,
  isPropertySaved: PropTypes.bool,
  setIsPropertySaved: PropTypes.func,
  setShowModal: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
  isModalOpen: PropTypes.bool,
  className: PropTypes.string,
};

CfdImageSection.defaultProps = {
  isGridOrList: false,
  isPropertySaved: false,
  activeTab: "",
  isModalOpen: false,
  className: "",
};

export default CfdImageSection;
